import type { Locale } from "@/lib/i18n/config";
import en from "@/lib/i18n/dictionaries/en";
import ptBR from "@/lib/i18n/dictionaries/pt-BR";
import es from "@/lib/i18n/dictionaries/es";
import id from "@/lib/i18n/dictionaries/id";
import th from "@/lib/i18n/dictionaries/th";
import de from "@/lib/i18n/dictionaries/de";
import type { Dictionary } from "@/lib/i18n/dictionaries/en";

export const dictionaries: Record<Locale, Dictionary> = {
  en,
  "pt-BR": ptBR,
  es,
  id,
  th,
  de,
};

export type { Dictionary };
